//Pārcel uz ready.js

$(document).ready(function ($) {
    const body = $("body");
    const fast_checkout = $(".fast-checkout");
    let windowsize = $(window).width();

    let mobile_menu_toggle = $(".mobile-menu-toggle");

    headerScroll($('.header'))

    if (windowsize <= 1025) {
        headerScroll($('.js-fixed-toggle'))
    }

    $('.header .button.button--cart').on('click tap', function(e) {
        body.addClass("show-fast-checkout")
        body.removeClass("show-search")
        mobile_menu_toggle.addClass("is-hidden");
        // renderFastCheckout()
    });
    $('.search-close-wrapper').on('click tap', function(e) {    
        body.removeClass("show-search")
    });
    fast_checkout.find('.close-fast-checkout').on('click tap', function(e) {
        body.removeClass("show-fast-checkout")
        mobile_menu_toggle.removeClass("is-hidden");
        $(".sidebars .body").scrollTop(0);
    });


});

function headerScroll(element){

    let body = $("body");

    let mainHeader = element,
        //this applies only if secondary nav is below intro section
        belowNavHeroContent = $('.sub-nav-hero'),
        search_bar = $(".search-bar"),
        headerHeight = mainHeader.height();

    //set scrolling variables
    let scrolling = false,
        previousTop = 0,
        scrollDelta = 10,
        scrollOffset = 150;

    mainHeader.on('click', '.nav-trigger', function()  {
        $(this).toggleClass('nav-open');
        return false;
    });

    $(window).on('scroll', function () {
        if (!scrolling) {
            scrolling = true;
            (!window.requestAnimationFrame)
                ? setTimeout(autoHideHeader, 250)
                : requestAnimationFrame(autoHideHeader);
        }
    });

    $(window).on('resize', function () {
        headerHeight = mainHeader.height();
    });

    function autoHideHeader() {
        let currentTop = $(window).scrollTop();

        if (!(belowNavHeroContent.length > 0)) {
            checkSimpleNavigation(currentTop)
        }

        previousTop = currentTop;
        scrolling = false;
    }

    function checkSimpleNavigation(currentTop) {
        //there's no secondary nav or secondary nav is below primary nav
        if (previousTop - currentTop > scrollDelta) {
            //if scrolling up...
            mainHeader.removeClass('is-hidden');
            mainHeader.addClass('show');
            search_bar.addClass('show');
            body.removeClass('is-hidden-sticky');
        } else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
            //if scrolling down...
            mainHeader.addClass('is-hidden');
            mainHeader.removeClass('show');
            search_bar.removeClass('show');
            body.addClass('is-hidden-sticky');
        }

        if(currentTop < scrollOffset) {
            mainHeader.removeClass('show');
            search_bar.removeClass('show');
        }

    }
}

